var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConnectionGrayIc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      width: 128,
      height: 128,
      opacity: 1
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M507.321,145.251l-18.08-18.071c-6.236-6.244-16.368-6.244-22.604,0.008l-90.906,90.905l-81.816-81.824 l90.898-90.897c6.244-6.244,6.253-16.376,0.008-22.612l-18.071-18.08c-6.244-6.244-16.369-6.236-22.614,0.008L253.23,95.593 l-47.144-47.144L192.588,34.95l-36.574,36.566l13.499,13.498l-1.166,1.175l-48.402,48.402 c-46.242,46.242-58.5,113.567-36.872,171.042l-24.82,24.82c-11.919,11.919-11.919,31.248,0,43.174l80.12,80.112 c11.926,11.927,31.256,11.918,43.174,0l24.82-24.821c57.475,21.645,124.809,9.388,171.051-36.863l48.393-48.402h0.009l1.166-1.166 l13.498,13.499l36.574-36.566l-13.507-13.506l-47.144-47.144l90.906-90.906C513.557,161.62,513.565,151.504,507.321,145.251z",
    style: {
      fill: "rgb(112, 112, 112)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0,463.036 48.956,512 105.479,455.477 56.524,406.513  ",
    style: {
      fill: "rgb(112, 112, 112)"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectionGrayIc);
export default __webpack_public_path__ + "static/media/connection_gray_ic.fe1b47891dac24f803e37062bb9f2b51.svg";
export { ForwardRef as ReactComponent };